import React, { useMemo } from 'react'
import { useContext } from '../Context'
import MainFilter from './mainFillter'
import { ListRow } from './ListRow'
import { useReportActions } from '../useReportActions'
import { Box } from '@ztechapps/webui.util'
import type { BodyRowConfig, HeaderRowConfig } from '@ztechapps/webui.data-tools'
import { DataTable, MenuHeaderCell } from '@ztechapps/webui.data-tools'
import { Col, Row } from 'react-bootstrap'
import { fields } from './constants'

export default () => {
  const { addFavorite, isInFavorites, reportTemplateCategories, templateCategories, ...context } = useContext()
  const [collapse, setCollapse] = React.useState(false)

  const onSelect = useReportActions({ reportTemplateCategories })
  const fieldConfig = useMemo(() => {
    return fields(templateCategories)
  }, [templateCategories])

  return (
    <Row>
      <Col md={collapse ? 1 : 3}>
        <MainFilter collapse={collapse} setCollapse={setCollapse} />
      </Col>
      <Col md={collapse ? 11 : 9}>
        <Box>
          <Box.Body>
            <DataTable
              name="reports-list"
              fields={fieldConfig}
              listResult={context}
              head={Header}
              row={(props: BodyRowConfig) => <ListRow {...props} {...{ addFavorite, isInFavorites, onSelect }} />}
              stats="reports"
              height={{ topMargin: 200 }}
              tableOptions={{
                style: { width: '100%' },
              }}
            />
          </Box.Body>
        </Box>
      </Col>
    </Row>
  )
}

const Header = (props: HeaderRowConfig) => {
  return (
    <>
      <MenuHeaderCell />
      {props._renderDataHeaderCell()}
      <th style={{ width: '10%' }}>Actions</th>
    </>
  )
}
